export default async function fetchSearchCategoriesData() {
    try {
        const endpointurl = "/api/v2/categories";
        const response = await fetch(endpointurl);
        return response;
    } catch (error) {
        throw error;
    }
}
